let flag = false;

const getFlag = () => {
    return flag;
}

const setFlag = (tmpFlag) => {
    flag = tmpFlag;
}

const SearchFlag = {
    getFlag,
    setFlag
};

export default SearchFlag;



// WEBPACK FOOTER //
// ./src/containers/Search/SearchFlag.js